import InstallmentsDataGrid from "./InstallmentsDataGrid.tsx";
import { PolicyValuesObject } from "../../types/insurance.ts";

type Props = {
  policies: PolicyValuesObject[];
  updatePolicyValueRow: (args: {
    rowIndex: number;
    columnId: string;
    value: any;
  }) => void;
  payPlaces: Record<string, string>;
  agents: Record<string, string>;
  stickers: any[];
  greenCards: any[];
  paymentAccounts: any[];
  addRow: () => void;
  deleteRow: (row: number) => void;
};

const PolicyValuesDataGrid: React.FC<Props> = ({
  policies,
  updatePolicyValueRow,
  payPlaces,
  agents,
  stickers,
  greenCards,
  paymentAccounts,
  addRow,
  deleteRow,
}) => {
  const onEditComplete = (props) => {
    const { rowIndex, value, columnId } = props;
    updatePolicyValueRow({ value, rowIndex, columnId });
  };

  return (
    <InstallmentsDataGrid
      data={policies}
      onChange={onEditComplete}
      payPlaces={payPlaces}
      agents={agents}
      stickers={stickers}
      greenCards={greenCards}
      paymentAccounts={paymentAccounts}
      addRow={addRow}
      deleteRow={deleteRow}
    />
  );
};

export default PolicyValuesDataGrid;
